import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Paginate from "src/shared/Paginate";

import { PeopleData } from "src/types/personData";

import PeopleList from "src/shared/PeopleList/PeopleList";
import Loader from "src/shared/Loader";
import { getPopularPeopleList } from "src/shared/api";

const PopularPeople = () => {
  const [data, setData] = useState<PeopleData | null>(null);

  let { currentPage } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getPopularPeopleList("popular", currentPage as string).then((response) =>
      setData(response.data),
    );
  }, [currentPage]);

  const handlePageChange = (selectedNumber: { selected: number }) => {
    navigate(`/popularpeople/${selectedNumber.selected + 1}`);
  };

  if (!data) {
    return <Loader />;
  }

  return (
    <div>
      <PeopleList people={data.results} />
      <Paginate onPageChange={handlePageChange} pageCount={data.total_pages} />
    </div>
  );
};

export default PopularPeople;
